import { authClient } from '../../lib/authClient';
import { routes } from '../../routes';
import { wipeLocalDatabase } from '../../rxdb/provider';
import Logo from '../Logo';
import { Menu, UnstyledButton, useMantineColorScheme } from '@mantine/core';
import dayjs from 'dayjs';
import {
  ChevronDown,
  LogOut,
  Mail,
  Moon,
  RectangleEllipsis,
  Sun,
  User,
} from 'lucide-react';
import { Link } from 'wouter';

export const AuthenticatedLayout: React.FC<{
  readonly children: React.ReactNode | React.ReactNode[];
  readonly headerRight?: React.ReactNode;
}> = ({ children, headerRight = null }) => {
  const { data: session } = authClient.useSession();
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();

  const headerRightJSX = headerRight ? <div>{headerRight}</div> : null;
  return (
    <div className="inset-0 absolute flex flex-col">
      <div className="bg-[#e8e4df] dark:bg-[#1a1d21]">
        <div className="flex leading-[60px] align-middle px-4">
          <div className="flex-1">
            <div className="w-[120px] inline-block align-middle">
              <Logo />
            </div>
          </div>
          {headerRightJSX}
          <Menu>
            <Menu.Target>
              <UnstyledButton className="leading-[50px] py-0 pr-[20px] pl-[10px]">
                <User
                  className="inline-block dark:fill-white"
                  fill="#000"
                  size={20}
                />
                <ChevronDown className="float-right m-0 mt-[17px] -mr-[20px]" />
              </UnstyledButton>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Label>{session?.user?.email}</Menu.Label>
              <Menu.Item
                component={Link}
                href={routes.resetPassword}
                leftSection={<RectangleEllipsis />}
              >
                Reset password
              </Menu.Item>
              <Menu.Item
                component={Link}
                leftSection={<Mail />}
                to={routes.invite}
              >
                Send Invite
              </Menu.Item>
              <Menu.Item
                leftSection={colorScheme === 'light' ? <Moon /> : <Sun />}
                onClick={toggleColorScheme}
              >
                {colorScheme === 'light' ? 'Dark mode' : 'Light mode'}
              </Menu.Item>
              <Menu.Divider />
              <Menu.Item
                color="red"
                leftSection={<LogOut />}
                onClick={async () => {
                  await wipeLocalDatabase();
                  await authClient.signOut();
                  document.location.assign(routes.signIn);
                }}
              >
                Sign out
              </Menu.Item>
              <Menu.Divider />
              <Menu.Label>
                v{dayjs("2026-07-23T18:24:51.756Z").format('YYYY-MM-DD')}
              </Menu.Label>
            </Menu.Dropdown>
          </Menu>
        </div>
      </div>
      <div
        className="grow overflow-hidden"
        id="clew-scroll-container"
      >
        {children}
      </div>
    </div>
  );
};
